import { render, staticRenderFns } from "./PdfModals.vue?vue&type=template&id=635cb355&scoped=true&"
import script from "./PdfModals.vue?vue&type=script&lang=js&"
export * from "./PdfModals.vue?vue&type=script&lang=js&"
import style0 from "./PdfModals.vue?vue&type=style&index=0&id=635cb355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb355",
  null
  
)

export default component.exports